import { Editor } from "@tiptap/react";
import { EditorState } from "@tiptap/pm/state";
import {
  defaultDataState,
  dynamicDataPluginKey,
  IDynamicData,
} from "./DataProvider";

export const getDynamicData = (
  editorState: EditorState | undefined,
): IDynamicData => {
  return editorState
    ? dynamicDataPluginKey.getState(editorState)
    : defaultDataState;
};

export const dispatchDataTransaction = (
  editor: Editor,
  dynamicData: IDynamicData,
) => {
  const { view, state } = editor;
  const transaction = state.tr.setMeta(dynamicDataPluginKey, { dynamicData });
  view.dispatch(transaction);
};
